import {useSearchParam} from "react-use";
import {isTokenValid} from "../../../utils/token";

export const useTokenSearchParam = () => {
  const token = useSearchParam("token");

  return isTokenValid(token) ? token : undefined;
};
